function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useEffect, useState } from "react";
import { useStripe, useElements, CardNumberElement, CardCvcElement, CardExpiryElement } from "@stripe/react-stripe-js";
var useOptions = function useOptions() {
  var options = useMemo(function () {
    return {
      style: {
        base: {
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Code Pro, monospace",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#9e2146"
        }
      }
    };
  }
  // [fontSize]
  );

  return options;
};
var StripeCheckoutForm = function StripeCheckoutForm(_ref) {
  var submitStripeCard = _ref.submitStripeCard,
    setStripeError = _ref.setStripeError,
    completeOrder = _ref.completeOrder,
    stripePaymentIntentClientSecret = _ref.stripePaymentIntentClientSecret,
    stripePaymentIntentActionType = _ref.stripePaymentIntentActionType,
    stripeSetupIntentClientSecret = _ref.stripeSetupIntentClientSecret,
    stripeSetupIntentActionType = _ref.stripeSetupIntentActionType,
    orderId = _ref.orderId,
    type = _ref.type,
    creditToken = _ref.creditToken,
    appProps = _ref.appProps,
    setIsLoading = _ref.setIsLoading,
    cardsPath = _ref.cardsPath,
    paymentMethodId = _ref.paymentMethodId,
    setCurrentCardPath = _ref.setCurrentCardPath,
    billingDetails = _ref.billingDetails,
    payableAlreadyCompleted = _ref.payableAlreadyCompleted;
  var stripe = useStripe();
  var elements = useElements();
  var options = useOptions();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    cards = _useState2[0],
    setCards = _useState2[1];
  var _useState3 = useState(appProps.user ? false : true),
    _useState4 = _slicedToArray(_useState3, 2),
    addNewCard = _useState4[0],
    setAddNewCard = _useState4[1];
  useEffect(function () {
    if (appProps.user) {
      setIsLoading(true);
      Rails.ajax({
        type: 'GET',
        url: "".concat(cardsPath, "?payment_method_id=").concat(paymentMethodId),
        dataType: 'json',
        success: function success(res) {
          setIsLoading(false);
          if (res.cards) {
            setCards(res.cards);
            setAddNewCard(res.cards.length == 0);
          }
        },
        error: function error(res) {
          setIsLoading(false);
          if (res.error) {
            appProps.flashMessage.show(res.error, 'error');
          }
        }
      });
    }
  }, []);
  useEffect(function () {
    if (submitStripeCard) {
      if (!stripe || !elements) {
        // Stripe.js has not loaded yet. Make sure to disable
        // form submission until Stripe.js has loaded.
        return;
      }
      if (!addNewCard) {
        var relevantCard = cards.find(function (card) {
          return card.current;
        });
        completeOrder(relevantCard.stripePaymentMethod);
      } else {
        stripe.createPaymentMethod({
          type: "card",
          card: elements.getElement(CardNumberElement),
          billing_details: billingDetails
        }).then(function (payload) {
          if (payload.error) {
            if (appProps.flashMessage) {
              appProps.flashMessage.show(payload.error.message, 'error');
            }
            setStripeError();
          } else {
            completeOrder(payload.paymentMethod.id);
          }
        });
      }
    }
  }, [submitStripeCard]);
  useEffect(function () {
    if (stripePaymentIntentClientSecret || stripeSetupIntentClientSecret) {
      if (stripePaymentIntentActionType === "requires_action" || stripeSetupIntentActionType === "requires_action") {
        // If the customer is required to pay at the time of booking we follow the normal flow
        // Otherwise we confirm the stripe setup(no payment is made)
        // A customer may not be charged initially if the reservation has a policy that
        // does not charge you at the time of booking

        if (stripePaymentIntentClientSecret) {
          stripe.confirmCardPayment(stripePaymentIntentClientSecret).then(function (payload) {
            if (payload.error) {
              if (appProps.flashMessage) {
                appProps.flashMessage.show(payload.error.message, 'error');
              }
              setStripeError();
              window.location.reload();
            } else {
              var formData = new FormData();
              formData.append('payment_intent_id', payload.paymentIntent.id);
              formData.append('orderid', orderId);
              formData.append('type', type);
              if (creditToken) {
                formData.append('credit_token', creditToken);
              }
              if (payableAlreadyCompleted) {
                formData.append('payable_already_completed', true);
              }
              Rails.ajax({
                url: '/stripe_payment/success',
                type: 'POST',
                dataType: 'json',
                accept: 'json',
                data: formData,
                success: function success(res) {
                  if (res.redirect_url) {
                    if (res.message) {
                      appProps.flashMessage.show(res.message, 'success');
                    }
                    window.location.href = res.redirect_url;
                  } else {
                    setStripeError();
                  }
                },
                error: function error(res) {
                  setStripeError();
                }
              });
            }
          });
        } else {
          stripe.confirmSetup({
            clientSecret: stripeSetupIntentClientSecret,
            redirect: 'if_required'
          }).then(function (payload) {
            if (payload.error) {
              if (appProps.flashMessage) {
                appProps.flashMessage.show(payload.error.message, 'error');
              }
              setStripeError();
              window.location.reload();
            } else {
              var formData = new FormData();
              formData.append('setup_intent_id', payload.setupIntent.id);
              formData.append('orderid', orderId);
              formData.append('type', type);
              if (creditToken) {
                formData.append('credit_token', creditToken);
              }
              if (payableAlreadyCompleted) {
                formData.append('payable_already_completed', true);
              }
              Rails.ajax({
                url: '/stripe_payment/success',
                type: 'POST',
                dataType: 'json',
                accept: 'json',
                data: formData,
                success: function success(res) {
                  if (res.redirect_url) {
                    window.location.href = res.redirect_url;
                  } else {
                    setStripeError();
                  }
                },
                error: function error(res) {
                  setStripeError();
                }
              });
            }
          });
        }
      } else if (stripePaymentIntentActionType === "requires_confirmation") {
        stripe.handleCardAction(stripePaymentIntentClientSecret).then(function (payload) {
          if (payload.error) {
            if (appProps.flashMessage) {
              appProps.flashMessage.show(payload.error.message, 'error');
            }
            setStripeError();
            window.location.reload();
          } else {
            var formData = new FormData();
            formData.append('payment_intent_id', payload.paymentIntent.id);
            formData.append('orderid', orderId);
            formData.append('type', type);
            if (creditToken) {
              formData.append('credit_token', creditToken);
            }
            Rails.ajax({
              url: '/stripe_payment/confirm_payment_intent',
              type: 'POST',
              dataType: 'json',
              accept: 'json',
              data: formData,
              success: function success(res) {
                if (res.redirect_url) {
                  window.location.href = res.redirect_url;
                } else {
                  setStripeError();
                }
              },
              error: function error(res) {
                setStripeError();
              }
            });
          }
        });
      }
    }
  }, [stripePaymentIntentClientSecret, stripeSetupIntentClientSecret]);
  var setPrimaryCard = function setPrimaryCard(card) {
    if (!card.current) {
      setIsLoading(true);
      var fd = new FormData();
      fd.append('card_details[id]', card.id);
      fd.append('card_details[payment_method_id]', paymentMethodId);
      Rails.ajax({
        type: 'POST',
        url: setCurrentCardPath,
        dataType: 'json',
        data: fd,
        success: function success(res) {
          if (res.cards) {
            setCards(res.cards);
          }
        },
        error: function error(res) {
          if (res.error) {
            appProps.flashMessage.show(res.error, 'error');
          }
        },
        complete: function complete(_) {
          setIsLoading(false);
        }
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, cards.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "switch-wrapper content-end m-b-30"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-box items-center"
  }, /*#__PURE__*/React.createElement("label", {
    className: "switch"
  }, /*#__PURE__*/React.createElement("input", {
    id: "add-new-card-toggle",
    type: "checkbox",
    name: "addNewCardToggle",
    defaultChecked: addNewCard,
    onChange: function onChange(_e) {
      return setAddNewCard(function (prevState) {
        return !prevState;
      });
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "slider round"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "switch-text"
  }, "Add new card")), !addNewCard && /*#__PURE__*/React.createElement("div", {
    className: "tokenized-cards-wrapper"
  }, cards.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      key: card.id,
      className: "tokenized-card ".concat(card.current ? 'current' : ''),
      style: {
        flexBasis: '100%'
      },
      onClick: function onClick() {
        return setPrimaryCard(card);
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://storage.googleapis.com/reactive_files_eu/payment_processors/card_issuers/".concat(card.issuer, ".svg"),
      style: {
        width: 50
      }
    }), ['amex', 'diners', 'discover', 'maestro', 'mastercard', 'visa'].includes(card.issuer) && /*#__PURE__*/React.createElement("div", {
      className: "tokenized-card-pan"
    }, "********".concat(card.panLast)));
  })), addNewCard && /*#__PURE__*/React.createElement("form", {
    className: "stripe-elements-wrapper"
  }, /*#__PURE__*/React.createElement("label", null, "Card number", /*#__PURE__*/React.createElement(CardNumberElement, {
    options: options,
    onReady: function onReady() {},
    onChange: function onChange(event) {},
    onBlur: function onBlur() {},
    onFocus: function onFocus() {}
  })), /*#__PURE__*/React.createElement("label", null, "Expiration date", /*#__PURE__*/React.createElement(CardExpiryElement, {
    options: options,
    onReady: function onReady() {},
    onChange: function onChange(event) {},
    onBlur: function onBlur() {},
    onFocus: function onFocus() {}
  })), /*#__PURE__*/React.createElement("label", null, "CVC", /*#__PURE__*/React.createElement(CardCvcElement, {
    options: options,
    onReady: function onReady() {},
    onChange: function onChange(event) {},
    onBlur: function onBlur() {},
    onFocus: function onFocus() {}
  })), /*#__PURE__*/React.createElement("div", {
    className: "stripe-copyright"
  }, /*#__PURE__*/React.createElement("div", {
    className: "stripe-logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://storage.googleapis.com/reactive_files_eu/payment_processors/stripe-logo.jpg"
  })), /*#__PURE__*/React.createElement("div", {
    className: "stripe-text"
  }, "Payments are powered, processed and fully secured by ", /*#__PURE__*/React.createElement("b", null, "Stripe"), ". We never keep credit card information in our systems."))));
};
export default StripeCheckoutForm;